import React, { useEffect, useState } from 'react';
import { Button, Icon } from '@gerdau/hefesto';
import { ICustomerBilletItem } from '../../../../../../store/ducks/download-area/types';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import {
  downloadBilletFile,
  loadBilletFile
} from '../../../../../../store/ducks/download-area/action';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { SpinnerIcon } from '../../../../../../components/Commons/SpinnerIcon/styles';
import TicketUnavailableModal from '../../../../../../components/TicketUnavailableModal';
import { downloadPdf } from '../../../../../../utils/createDownloadFile';
import {
  RcaKind,
  sendRcaLogs
} from '../../../../../../store/ducks/observability/actions';

interface IBilletDownloadButton {
  billetData: ICustomerBilletItem;
}
const BilletDownloadButton: React.FC<IBilletDownloadButton> = ({
  billetData
}) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { screenName = '' } = getTaggingInformationScreen('download-area');
  const { itemDescription = '' } = getTaggingInformationScreen('2avia-boleto');

  const handleDownloadBillet = () => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:2aViaDeBoleto`,
        itemDescription: `${itemDescription}baixar`,
        itemName: `button:baixar`,
        event: 'click'
      })
    );

    const invoiceType = billetData.invoiceType?.toUpperCase();

    if (invoiceType === 'D' || invoiceType === 'M') {
      setIsModalOpen(true);
    } else {
      if (
        billetData?.billetState?.invoiceBilletResponse &&
        billetData?.billetState?.invoiceBilletResponse.pdfContent
      ) {
        downloadPdf(billetData.billetState?.invoiceBilletResponse.pdfContent);
      } else {
        dispatch(loadBilletFile(billetData));
        dispatch(
          sendRcaLogs(RcaKind.DownloadItem, 'BILF', billetData.billingNumber)
        );
      }
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const downloadInvoiceBilletFromUseEffect = () => {
    if (!billetData.billetState?.invoiceBilletResponse) {
      return;
    }

    dispatch(downloadBilletFile(billetData));
    dispatch(
      sendRcaLogs(
        RcaKind.DownloadItem,
        'BILLET',
        `${billetData.billingNumber}:${billetData.orderNumber}`
      )
    );
    downloadPdf(billetData.billetState.invoiceBilletResponse.pdfContent);
  };

  useEffect(() => {
    if (
      billetData &&
      !billetData.billetState?.alreadyDownloaded &&
      billetData.billetState?.invoiceBilletResponse
    ) {
      downloadInvoiceBilletFromUseEffect();
    }
  });

  return (
    <div>
      <Button
        name="exportDuplicate"
        onClick={handleDownloadBillet}
        icon={
          billetData.billetState?.loading ? (
            <SpinnerIcon style={{ margin: '0.125rem' }} />
          ) : (
            <Icon option="Download" />
          )
        }
        iconPosition="left"
        variant="tertiary"
        disabled={
          billetData.billetState?.loading ||
          billetData.bankSlipNumber === '' ||
          billetData.bankCode === ''
        }
      >
        {billetData.billetState?.loading ? <>Baixando</> : <>Baixar</>}
      </Button>
      {isModalOpen && (
        <TicketUnavailableModal
          message="Verifique as condições de pagamento do seu pedido"
          title="Boleto indisponível"
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default BilletDownloadButton;
